function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9BADBC",
  fillRule: "evenodd",
  d: "M3.876 4.423l4.13-4.13A1 1 0 019.268.168l.068.045a.739.739 0 01.112 1.138L3.793 7.006a1 1 0 01-1.414 0L.293 4.92a1 1 0 010-1.414l.043-.043a.95.95 0 011.412.078l.64.8a1 1 0 001.488.082z"
});

var SvgCheckmarkIcon = function SvgCheckmarkIcon(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8"
  }, props), _ref);
};

export default SvgCheckmarkIcon;